import { render, staticRenderFns } from "./LaravelMixHack.vue?vue&type=template&id=353388f8"
import script from "./LaravelMixHack.vue?vue&type=script&lang=js"
export * from "./LaravelMixHack.vue?vue&type=script&lang=js"
import style0 from "./LaravelMixHack.vue?vue&type=style&index=0&id=353388f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports